<template>
  <div>
    <el-form
      label-width="80px"
      @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="调拨方向:">
            <!-- <el-radio-group
              v-model="config.allocateDirection"
              style="margin-right: 10px;vertical-align: top;"
              @change="handleCurrentChange(1)">
              <el-radio-button :label="1">发货</el-radio-button>
              <el-radio-button :label="2">退货</el-radio-button>
            </el-radio-group> -->
            <el-select
              v-model="config.allocateDirection"
              style="width: 100%"
              placeholder="请选择调拨方向"
              @change="handleCurrentChange(1)">
              <el-option
                :key="1"
                label="发货"
                :value="1">
              </el-option>
              <el-option
                :key="2"
                label="退货"
                :value="2">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间:">
            <date-range-select
              v-model="daterange"
              title="创建"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调拨状态:">
            <allocate-status-select
              v-model="config.status"
              style="width: 100%"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调出仓库:">
            <ent-warehouse-auto-select
              v-model="config.sourceWarehouseNo"
              placeholder="请输入调出仓库名称"
              style="width: 100%"
              :callback="() => {handleCurrentChange(1)}" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调入仓库:">
            <ent-warehouse-auto-select
              v-model="config.destWarehouseNo"
              placeholder="请输入调入仓库名称"
              style="width: 100%"
              :callback="() => {handleCurrentChange(1)}" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="调拨单号:">
            <el-input
              v-model="config.code"
              clearable=""
              placeholder="请输入调拨单号"
              @keyup.enter.native="handleCurrentChange(1)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="">
            <el-button
              type="primary"
              @click="handleCurrentChange(1)">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      border
      :data="list">
      <el-table-column
        label="调拨单号"
        width="140"
        fixed="left"
        :resizable="false"
        prop="code">
        <template slot-scope="{row}">
          <link-route :link-to="`/transfer-stock-detail?vendorId=${row.parentOwnerCode}&allocateOrderId=${row.id}&code=${row.code}`">
            {{ row.code }}
          </link-route>
        </template>
      </el-table-column>
      <el-table-column
        label="业务调拨单号"
        width="130"
        :resizable="false"
        prop="outerOrderCode">
      </el-table-column>
      <el-table-column
        label="调出仓库"
        min-width="140"
        :resizable="false"
        prop="sourceWarehouseNo">
        <template slot-scope="{row}">
          {{ row.sourceWarehouseNo | warehouseName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="调入仓库"
        min-width="140"
        :resizable="false"
        prop="destWarehouseNo">
        <template slot-scope="{row}">
          {{ row.destWarehouseNo | warehouseName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="调拨类型"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          <span v-if="row.type===1">分布调拨</span>
          <span v-if="row.type===2">直接调拨</span>
        </template>
      </el-table-column>
      <el-table-column
        label="调拨状态"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.status | allocateStatusName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="发货方式"
        width="80"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.transType | transTypeName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="收货人"
        min-width="110"
        :resizable="false">
        <template slot-scope="{row}">
          <div>{{ row.receiverName }}</div>
          <!-- <div> {{ row.receiverProvince }}{{ row.receiverCity }}{{ row.receiverDistrict }}-{{ row.receiverAddress }}</div> -->
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        min-width="140"
        :resizable="false"
        prop="remark">
      </el-table-column>
      <el-table-column
        label="创建时间"
        :resizable="false"
        width="150">
        <template slot-scope="{row}">
          {{ row.createTime | dateformat( ) }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="config.allocateDirection === 1"
        :key="1111"
        label="操作"
        fixed="right"
        :resizable="false"
        width="235">
        <template slot-scope="{row}">
          <template v-if="row.allocateDirection === 1">
            <el-button
              :disabled="!(row.type === 1 && row.status === 1)"
              type="primary"
              @click.native="check(row)">
              审单
            </el-button>
            <el-button
              :disabled="!(row.type === 1 && (row.status === 2 || row.status === 4))"
              type="success"
              @click.native="addout(row)">
              建单
            </el-button>
            <!-- <el-button
              :disabled="!(row.status > 1 && row.status < 8)"
              type="danger"
              @click.native="allocatefinish(row)">
              关闭
            </el-button> -->
            <el-dropdown>
              <el-button
                type="info"
                style="margin-left: 10px">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="!(row.status > 1 && row.status < 8)"
                  @click.native="allocatefinish(row)">关闭</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status > 1 && row.status < 8)"
                  @click.native="allocatefinish(row, true)">无码出库</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 2)"
                  @click.native="allocatedeaudit(row)">反审</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <allocate-audit-modal
      ref="audit"
      :callback="fetchList" />
    <allocate-out-modal
      ref="out"
      :callback="fetchList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EntWarehouseAutoSelect from '../../../components/business/ent-warehouse-auto-select.vue'
import DateRangeSelect from '../../orders/date-range-select.vue'
import AllocateAuditModal from './allocate-audit-modal.vue'
import AllocateOutModal from './allocate-out-modal.vue'

import moment from 'moment'
import AllocateStatusSelect from '../allocate-status-select.vue'
export default {
  name: 'AllocateList',
  components: { EntWarehouseAutoSelect, AllocateAuditModal, AllocateOutModal, DateRangeSelect, AllocateStatusSelect },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        type: 1,
        status: null,
        allocateDirection: 1,
        sourceWarehouseNo: null,
        destWarehouseNo: null
      },
      daterange: null,
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    allocatedeaudit(row) {
      this.$confirm('此操作将反审该调拨单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/allocatedeaudit', {
            payload: {
              allocateOrderId: row.id
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    allocatefinish(row, forcedDelivery) {
      this.$confirm(`此操作将对该调拨单进行${forcedDelivery ? '无码出库' : '强制关闭'}, 是否继续?`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/allocatefinish', {
            payload: { allocateOrderId: row.id, forcedDelivery },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    check(row) {
      this.$refs.audit.fetch(row)
    },
    addout(row) {
      this.$refs.out.fetch(row.id)
    },
    createOut(row) {
      this.$confirm('此操作将创建调拨出库单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('outstock/allocatedetail', {
          payload: {
            allocateOrderId: row.id
          },
          success: res => {
            this.loading = true
            const data = res.data.data
            this.$store.dispatch('outstock/outadd', {
              payload: {
                bizOrderId: data.id,
                expressCode: data.expressCode,
                detailList: data.detailList.map(s => {
                  return {
                    // 'outOrderId': this.orderInfo.id,
                    // 'id': ''
                    bizOrderDetailId: s.id, // 业务单明细id',
                    skuId: s.skuId,
                    num: s.num,
                    stockId: s.warehouse.id // 库存id,仓库库存Id【必须】',
                  }
                }),
                outType: 1,
                transType: 1,
                type: 23,
                warehouseNo: data.sourceWarehouseNo
              },
              success: () => {
                this.loading = false
                this.$refs.table.clearSelection()
                this.fetchList()
              },
              fail: () => {
                this.loading = false
              }
            })
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const [createTimeStart, createTimeEnd] = this.daterange || [null, null]
      this.$store.dispatch('outstock/allocatelist', {
        payload: {
          ...this.config,
          createTimeStart: +moment(createTimeStart).startOf('days'),
          createTimeEnd: +moment(createTimeEnd).endOf('days')
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
